var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('p',[(_vm.row.change > 0)?_c('span',{staticStyle:{"color":"green"}},[_vm._v("↑")]):_vm._e()]),_vm._v(" "),_c('p',[(_vm.row.change < 0)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("↓")]):_vm._e()]),_vm._v(" "),_c('p',[(!_vm.row.change)?_c('span'):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }